module.exports = __webpack_public_path__ + "static/young-woman-with-sunglasses-smiling-91ddab27de651f7e5a4f3e9f6b16efd8.jpg";